import { Component } from "@angular/core";

@Component({
	selector: "card-spacer",
	templateUrl: "./card-spacer.component.html",
})
export class CardSpacerComponent {}
